export default __webpack_public_path__ + "static/media/J.53422269.svg";